import {
  CLEAR_ACTIVE_FLIGHT,
  SET_ACTIVE_FLIGHT,
  UPDATE_ACTIVE_FLIGHT,
  UPDATE_FLIGHT_MAP,
  UPDATE_FLIGHT_LIST,
} from 'actions';
import { subtractTimeFromNow } from 'utils';

export function activeFlight(state = {}, action) {
  switch (action.type) {
    case SET_ACTIVE_FLIGHT:
    case UPDATE_ACTIVE_FLIGHT:
      return action.activeFlight;
    case CLEAR_ACTIVE_FLIGHT:
      return null;
    default:
      return state;
  }
}

export function flightMap(state = [], action) {
  switch (action.type) {
    case UPDATE_FLIGHT_MAP:
      // extract the updated flight list from action
      // this is the collection of new / updated flights
      const { flightMap: updatedFlightList } = action;

      let currentState = state && state instanceof Map ? state : new Map();

      // if flight list is empty return the current list
      if (!updatedFlightList || updatedFlightList.size < 1) {
        return currentState;
      }

      for (const currentFlightId of currentState.keys()) {
        // If the flight is updated
        // Update the currentFlight list
        // Delete from the updated flight list (new list)
        if (updatedFlightList?.has(currentFlightId)) {
          currentState.set(
            currentFlightId,
            updatedFlightList.get(currentFlightId),
          );
          updatedFlightList.delete(currentFlightId);
        }
      }

      // concat new flights and remove flights that are older than 30 days
      const dt30DaysAgo = subtractTimeFromNow(30, 'days');
      currentState = new Map([...currentState, ...updatedFlightList]);
      currentState.forEach((flight) => {
        if (flight.modified < dt30DaysAgo) {
          currentState.delete(flight.id);
        }
      });

      // return the result
      return currentState;
    default:
      return state;
  }
}

export function flightList(state = [], action) {
  switch (action.type) {
    case UPDATE_FLIGHT_LIST:
      return action.flightList;
    default:
      return state;
  }
}
